<template>
    <form id="form-transfer" class="bg-white rounded pt-4 md:mr-6 mr-0 shadow-card mb-4 md:mb-0">
        <title-section class="ml-7" :title="title" @go-back="$emit('go-back')" />

        <div
            id="form-values"
            class="mt-4 w-full md:overflow-y-auto table md:block px-7"
            :class="styles.formPbBottom"
            :style="{ height: styles.height, maxHeight: styles.maxHeight }"
        >

            <div v-if="$slots.pix || $slots.favored">
                <slot name="favored" />
                <slot name="pix" />
            </div>

            <div v-if="$slots.account" :class="paddindTopInputs">
                <slot name="account" />
            </div>

            <div :class="$slots.pix || $slots.favored ? paddindTopInputs : ''">
                <jet-label class="text-gray-800" :value="'Valor'" />
                <div class="relative">
                    <span class="absolute text-xs font-bold left-4 top-4 leading-none">R$</span>
                    <jet-decimal
                        id="amount"
                        type="text"
                        class="mt-1 block w-full text-md"
                        maxlength="11"
                        :value="form.amount"
                        :readonly="optionsInputs ? optionsInputs.amount.readonly : false"
                        @input="$emit('input', { type: 'amount', value: $event })"
                    />
                    <jet-input-error :message="form.error('amount') || errors.amount" class="absolute -bottom-5" />
                </div>
            </div>

            <div v-if="$slots.schedule" :class="paddindTopInputs">
                <slot name="schedule" />
            </div>

            <div v-if="$slots.goal" :class="paddindTopInputs">
                <slot name="goal" />
            </div>

            <div :class="`${paddindTopInputs} ${optionsInputs ? optionsInputs.receiver_code.class : ''}`">
                <div class="flex justify-between">
                    <jet-label class="text-gray-800" :value="'Identificador de cobrança'" />
                    <jet-label class="text-gray-300 opacity-60" :value="'Opcional'" />
                </div>
                <jet-input
                    id="identify"
                    type="text"
                    class="mt-1 block w-full text-md"
                    maxLength="40"
                    :value="form.receiver_code"
                    :readonly="optionsInputs ? optionsInputs.receiver_code.readonly : false"
                    @input="$emit('input', { type: 'receiver_code', value: $event })"
                />
                <jet-input-error :message="form.error('receiver_code')" class="mt-2" />
            </div>

            <div :class="`${paddindTopInputs} ${optionsInputs ? optionsInputs.description.class : ''}`">
                <div class="flex justify-between">
                    <jet-label class="text-gray-800" :value="'Descrição'" />
                    <jet-label class="text-gray-300 opacity-60" :value="'Opcional'" />
                </div>
                <jet-textarea
                    class="w-full h-20 rounded-md border border-solid border-black text-gray-700 py-3 px-3 resize-none text-sm mt-1"
                    maxlength="40"
                    :value="form.description"
                    :readonly="optionsInputs ? optionsInputs.description.readonly : false"
                    @input="$emit('input', { type: 'description', value: $event })"
                />
            </div>
            <slot name="actions"/>
        </div>
    </form>
</template>
<script>
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import JetDecimal from "../../../Jetstream/Decimal.vue";
import JetLabel from "../../../Jetstream/Label.vue";
import JetTextarea from "../../../Jetstream/Textarea.vue";
import TitleSection from './TitleSection.vue';

export default {
    name: 'FormValues',
    props: {
        form: { type: Object, default: () => ({ }) },
        paddindTopInputs: { type: String, default: 'mt-6' },
        title: { type: String, default: 'Preencha os campos' },
        errors: { type: Object, default: () => ({ }) },
        optionsInputs: { type: [Object, null], default: null }
    },
    computed: {
        styles(){
            const styles = {}
            if(this.$attrs['form-height']){
                styles.height = this.$attrs['form-height']
            }
            if(this.$attrs['wrapper-max-height']){
                styles.maxHeight = this.$attrs['wrapper-max-height']
            }
            if(this.$attrs['form-pb-bottom']){
                styles.formPbBottom = this.$attrs['form-pb-bottom']
            }
            return styles
        }
    },
    components: {
        JetInput,
        JetDecimal,
        JetLabel,
        JetTextarea,
        JetInputError,
        TitleSection
    }
}
</script>
<style>
#form-transfer .vs__dropdown-toggle{
    position: relative;
}
#form-transfer .vs__actions{
    position: absolute;
    right: 0;
    top: 12px;
    background: white;
    padding-left: 6px;
}
#form-transfer .vs__actions .vs__clear{
    position: static;
}
</style>
